import React from 'react';

import { IBVOption } from '../../../../models/BVControls/IBVOption';

import BVRadioGroup from '../../../BVControls/BVRadioGroup/bv-radio-group';

interface IBVGender {
    className?: string;
    label?: string;
    data: IBVOption[];
    properties: any;
}

const BVGender: React.FunctionComponent<IBVGender> = ({ className, data, label, properties }) => (
    <BVRadioGroup className={className} data={data} label={label} properties={properties} />
);

export default BVGender;